import type { PropType } from 'vue';
import type { TTabBarProps } from './TTabBar.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent, ref, watch } from 'vue';
import { useStyles } from './TTabBar.styles';

export const TTabBar = defineComponent({
  name: 'TTabBar',
  emits: ['input', 'change', 'update:modelValue'],
  props: {
    labels: Array as PropType<TTabBarProps['labels']>,
    value: String as PropType<TTabBarProps['value']>,
    modelValue: String as PropType<TTabBarProps['modelValue']>,
  },
  setup(_props, { attrs, emit }) {
    const props = computed(() => merge({}, _props, attrs));
    const baseClass = useStyles();

    const selected = ref(props.value.modelValue !== undefined
      ? props.value.modelValue
      : props.value.value);
    watch([() => props.value.modelValue, () => props.value.value], () => {
      selected.value
        = props.value.modelValue !== undefined
          ? props.value.modelValue
          : props.value.value;
    });

    const handleOnClick = (label: string) => {
      emit('update:modelValue', label);
      emit('input', label);
      emit('change', label);
      selected.value = label;
    };

    return () => (
      <nav class={[baseClass.value]}>
        <ul
          class={[`${baseClass.value}__ul`, `${baseClass.value}`]}
          role="tablist"
        >
          {props.value.labels?.map((label) => (
            <li role="tab" aria-selected={selected.value === label} key={label}>
              <button
                class={[
                  `${baseClass.value}__button`,
                  {
                    [`${baseClass.value}__selected`]: selected.value === label,
                    [`${baseClass.value}__not-selected`]:
                      selected.value !== label,
                  },
                ]}
                onClick={() => handleOnClick(label)}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    );
  },
});
